export const categories = [
  {
    name: {
      pt: "Igreja - Cerimónia",
      en: "Church Ceremony",
      fr: "Cérémonie à l'église",
      es: "Ceremonia en la iglesia"
    },
    question: {
      id: '5e2980c4f980c67ce59d8072',
      type: 'chapter',
      section: 'ceremony'
    },
    fixed: true,
    important: true
  },
  {
    name: {
      pt: "Cerimónia no Espaço",
      en: "Ceremony at the Venue",
      fr: "Cérémonie sur le lieu",
      es: "Ceremonia en el lugar"
    },
    question: {
      id: '5e2980c4f980c67ce59d8072',
      type: 'chapter',
      section: 'ceremony'
    },
    fixed: true,
    important: true
  },
  {
    name: {
      pt: "Saída da Igreja",
      en: "Exit from the Church",
      fr: "Sortie de l'église",
      es: "Salida de la Iglesia"
    },
    question: {
      id: '',
      type: '',
      section: ''
    },
    fixed: true,
    important: false
  },
  {
    name: {
      pt: "Receção dos Convidados",
      en: "Guests Arrival",
      fr: "Arrivée des invités",
      es: "Llegada de los invitados"
    },
    question: {
      id: '',
      type: '',
      section: ''
    },
    fixed: true,
    important: true
  },
  {
    name: {
      pt: "Receção dos Noivos",
      en: "Couple Arrival",
      fr: "Arrivée des mariés",
      es: "Llegada de los novios"
    },
    question: {
      id: '',
      type: '',
      section: ''
    },
    fixed: true,
    important: true
  },
  {
    name: {
      pt: "Início dos Aperitivos",
      en: "Aperitifs/cocktail Begin",
      fr: "Début des apéritifs / cocktail",
      es: "Inicio del aperitivo / cóctel"
    },
    question: {
      id: '5e1e55866c3074ec5f29e568',
      type: 'question',
      section: 'food'
    },
    fixed: true,
    important: true
  },
  {
    name: {
      pt: "Fotos com os Convidados",
      en: "Photos with guests",
      fr: "Photos avec les invités",
      es: "Fotos con los invitados"
    },
    question: {
      id: '',
      type: '',
      section: ''
    },
    fixed: true,
    important: false
  },
  {
    name: {
      pt: "Sunset",
      en: "Sunset",
      fr: "Sunset",
      es: "Sunset"
    },
    question: {
      id: '',
      type: '',
      section: ''
    },
    fixed: true,
    important: false
  },
  {
    name: {
      pt: "Lançamento do Ramo",
      en: "Bouquet Toss",
      fr: "Lancer du Bouquet",
      es: "Lanzamiento del Ramo"
    },
    question: {
      id: '',
      type: '',
      section: ''
    },
    fixed: true,
    important: false
  },
  {
    name: {
      pt: "Entrada na Sala de Jantar",
      en: "Entrance into the Dining Room",
      fr: "Entrée dans la salle de réception",
      es: "Entrada al salón"
    },
    question: {
      id: '5e171e77fe9a64658f951372',
      type: 'chapter',
      section: 'food'
    },
    fixed: true,
    important: true
  },
  {
    name: {
      pt: "Início do Jantar",
      en: "Dinner is Served",
      fr: "Service du dîner",
      es: "Se sirve la cena"
    },
    question: {
      id: '',
      type: '',
      section: ''
    },
    fixed: true,
    important: true
  },
  {
    name: {
      pt: "Fim de Jantar",
      en: "End of Dinner",
      fr: "Fin du dîner",
      es: "Fin de la cena"
    },
    question: {
      id: '5e358dd3c51c94faab29de3a',
      type: 'question',
      section: 'food'
    },
    fixed: true,
    important: true
  },
  {
    name: {
      pt: "Abertura do Baile e Início Buffets",
      en: "Opening of the Dance Floor & Night Buffet",
      fr: "Ouverture de la piste de danse & buffet de nuit",
      es: "Apertura de la pista de baile y buffet nocturno"
    },
    question: {
      id: '',
      type: '',
      section: ''
    },
    fixed: true,
    important: true
  },
  {
    name: {
      pt: "Corte do Bolo",
      en: "Cake Cutting",
      fr: "Découpe du gâteau",
      es: "Corte de la tarta de novios"
    },
    question: {
      id: '5e1e5ea16c30744d0929e57a',
      type: 'chapter',
      section: 'food'
    },
    fixed: true,
    important: true
  },
  {
    name: {
      pt: "Ceia",
      en: "Late-night Snacks",
      fr: "Snacks de fin de soirée",
      es: "Snacks de medianoche"
    },
    question: {
      id: '5e1ecc966c3074ae7229e586',
      type: 'chapter',
      section: 'food'
    },
    fixed: true,
    important: true
  },
  {
    name: {
      pt: "Fim do Evento",
      en: "End of the Event",
      fr: "Fin de l'événement",
      es: "Fin del Evento"
    },
    question: {
      id: '',
      type: '',
      section: ''
    },
    fixed: true,
    important: true
  }
];

export const addNewMoment = (categories, moment) => {
  categories.push(
    {
      name: {
        pt: moment,
        en: moment,
        fr: moment,
        es: moment
      },
      question: {
        id: '',
        type: '',
        section: ''
      },
      fixed: false,
      important: false
    }
  );

  return categories;
}

export const checkMomentExists = (categories, moment) => {
  let exists = false;
  
  for(let i = 0; i < categories.length; i++) {
    if(
      categories[i].name.pt === moment || 
      categories[i].name.en === moment ||
      categories[i].name.fr === moment ||
      categories[i].name.es === moment
    ) {
      exists = true;
      break;
    }
  }

  return exists;
}

//Only for fixed Moments
export const findMoment = (moment) => {
  let found = undefined;

  for(let i = 0; i < categories.length; i++) {
    if(
      (categories[i].name.pt === moment || 
      categories[i].name.en === moment ||
      categories[i].name.fr === moment ||
      categories[i].name.es === moment) &&
      categories[i].fixed
    ) {
      found = categories[i];
      break;
    }
  }

  return found;
}